import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";

// Apply the theme before the first paint. The Header sets this class too, but
// only once it mounts — and it never mounts on the signed-out screens — so
// without this the app flashes light on every load and the auth screens ignore
// the choice entirely.
//
// Dark is the default: the workspace was designed on the dark canvas, and light
// is the opt-out (Header > theme toggle, stored in `darkMode`).
try {
  const savedMode = localStorage.getItem("darkMode");
  if (savedMode === null || JSON.parse(savedMode)) {
    document.documentElement.classList.add("dark");
  }
} catch {
  // Blocked storage — still start dark, matching the default above.
  document.documentElement.classList.add("dark");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("Service worker registered:", registration);
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
